// @flow
import * as React from 'react';
import { EmptyCard } from 'components';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { logout } from 'ducks/authActions';
import { logout as clearSession } from './logoutApi';
import TokenUtils from 'api/auth/TokenUtils';

export class Logout extends React.Component<
  {
    logout: () => void,
  },
  { redirect: boolean }
> {
  state: { redirect: boolean } = {
    redirect: false,
  };
  redirectTimeout: TimeoutID;

  componentDidMount() {
    // clear session
    const token = TokenUtils.getToken();
    if (token) {
      clearSession(token);
    }

    this.props.logout();

    this.redirectTimeout = setTimeout(() => {
      this.setState({ redirect: true });
    }, 2000);
  }

  componentWillUnmount() {
    clearTimeout(this.redirectTimeout);
  }

  render() {
    return (
      <EmptyCard modal>
        <EmptyCard.Title>You have been logged out.</EmptyCard.Title>
        {this.state.redirect && <Redirect to="/" />}
      </EmptyCard>
    );
  }
}

export default connect(null, { logout })(Logout);



// WEBPACK FOOTER //
// ./src/pages/logout/Logout.js